<tt-page class="col-xs-12 col-md-6 sp-0" *ngIf="!!setting">
    <tt-card>
        <tt-select ttRememberId="w_stockcontrolsplist.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
    </tt-card>

    <tt-list [ttData]="itemsListControls"></tt-list>

    <tt-card *ngIf="setting.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>
